import React from 'react';
import { VideoLandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingMp4ToMp3ConverterConfig } from '@/data/landingConfig/landingMp4ToMp3ConverterConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_Mp4ToMp3Converter } from './schemaObject';

interface Props {}
const Mp4ToMp3Converter: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_Mp4ToMp3Converter} />
			<VideoLandingTemplate
				data={landingMp4ToMp3ConverterConfig}
				funnelLinkService={GenerateLandingLinkService.funnelVideoConverter()}
			/>
		</>
	);
};

export default Mp4ToMp3Converter;
